// src/features/inventory/useInventoryQueries.js
import { useQueryClient } from "@tanstack/react-query";

export const INVENTORY_QUERY_KEYS = {
  all: ["inventory"],

  warehouses: () => [...INVENTORY_QUERY_KEYS.all, "warehouses"],

  warehouseProducts: (params = {}) => [
    ...INVENTORY_QUERY_KEYS.all,
    "warehouse-products",
    params,
  ],

  productTable: (params = {}) => [
    ...INVENTORY_QUERY_KEYS.all,
    "product-table",
    params,
  ],

  exportData: (params = {}) => [
    ...INVENTORY_QUERY_KEYS.all,
    "export",
    params,
  ],
};

export const useInventoryQueryActions = () => {
  const queryClient = useQueryClient();

  const invalidateWarehouses = () =>
    queryClient.invalidateQueries({
      queryKey: INVENTORY_QUERY_KEYS.warehouses(),
    });

  const invalidateWarehouseProducts = () =>
    queryClient.invalidateQueries({
      queryKey: [...INVENTORY_QUERY_KEYS.all, "warehouse-products"],
    });

  const invalidateProductTable = () =>
    queryClient.invalidateQueries({
      queryKey: [...INVENTORY_QUERY_KEYS.all, "product-table"],
    });

  const invalidateAllInventory = () =>
    queryClient.invalidateQueries({
      queryKey: INVENTORY_QUERY_KEYS.all,
    });

  return {
    invalidateWarehouses,
    invalidateWarehouseProducts,
    invalidateProductTable,
    invalidateAllInventory,
  };
};
